import { Component, Input, OnChanges } from '@angular/core';
import { TypedChanges } from '@platform-frontend/util';
import { StatusTagConfiguration } from '../status-tag-configuration';

@Component({
  selector: 'yat-status-tag',
  templateUrl: './status-tag.component.html',
  styleUrls: ['./status-tag.component.scss']
})
export class StatusTagComponent implements OnChanges {
  @Input()
  id: string;

  @Input()
  status: string = '';

  @Input()
  transparent: boolean = false;

  @Input()
  configurations: StatusTagConfiguration[] = [];

  @Input()
  leftMargin: boolean = true;

  displayedConfiguration?: StatusTagConfiguration;

  ngOnChanges(changes: TypedChanges<StatusTagComponent>): void {
    if (changes.status || changes.configurations) {
      this.displayedConfiguration = this.configurations.find(configuration => configuration.status === this.status);
    }
  }
}
